/*
 *
 * StoreSelect
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 08-Apr-2025
*/

import StoreSelect from './StoreSelect'

export default StoreSelect
